import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'
import { createHeadersMap } from './headers'

export const useQueryHeaders = () => {
  const searchParams = useSearchParams()
  const headersMap = useMemo(
    () => createHeadersMap(searchParams.entries()),
    [searchParams]
  )
  return headersMap
}
